export default __webpack_public_path__ + "static/media/IO.10445775.svg";